import { useCallback, useEffect, useState } from 'react'
import { superadminDashboardApi, type BoardColumnId, type BoardResponse } from '@/services/api/superadminDashboard'
import { extractErrorMessage } from '@/utils/errorHandler'

export function useSuperadminBoard() {
  const [board, setBoard] = useState<BoardResponse | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [moving, setMoving] = useState<string | null>(null)

  const load = useCallback(async () => {
    setError(null)
    try {
      const data = await superadminDashboardApi.getBoard()
      setBoard(data)
    } catch (err) {
      setError(extractErrorMessage(err, { loadError: 'Board konnte nicht geladen werden' }))
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void load()
  }, [load])

  const moveCard = useCallback(async (key: string, column: BoardColumnId) => {
    setMoving(key)
    setError(null)
    try {
      const data = await superadminDashboardApi.moveCard(key, column)
      setBoard(data)
    } catch (err) {
      setError(extractErrorMessage(err, { loadError: 'Karte konnte nicht verschoben werden' }))
    } finally {
      setMoving(null)
    }
  }, [])

  return { board, loading, error, moving, reload: load, moveCard }
}
